import React from 'react';
import { CodeMappingItems } from './code-mapping-items';
import { CodeMappingResultsProps } from 'app/area/code-mappings/components/types';

export const CodeMappingResults: React.FC<CodeMappingResultsProps> =
  ({ id, importSetId, mappingsList, modifiedMappings, codetableIds, missingMappingsExists,
    updatingExternalValue, metadata, codetableOptions, codetableAccess, fetchingItemId, validation, 
    translation, modifyItem, copyToAll, loadMetadata, loadCodetableOptions, loadCodetablesAccess,
    loadCategoryOptions, loadItem }) =>
    <CodeMappingItems
      id={id}
      importSetId={importSetId}
      mappingsList={mappingsList}
      modifiedMappings={modifiedMappings}
      modifyItem={modifyItem}
      codetableIds={codetableIds}
      copyToAll={copyToAll}
      missingMappingsExists={missingMappingsExists}
      validation={validation}
      translation={translation}
      codetableOptions={codetableOptions}
      fetchingItemId={fetchingItemId}
      updatingExternalValue={updatingExternalValue}
      loadItem={loadItem}
      loadCodetableOptions={loadCodetableOptions}
      loadCategoryOptions={loadCategoryOptions}
      codetableAccess={codetableAccess}
      loadCodetablesAccess={loadCodetablesAccess}
      loadMetadata={loadMetadata}
      metadata={metadata}
    />;
